/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Imageviewer_Loading_ImageInputs */



/**
* | output |
* | --- |
* | "Loading image..." |
*
* @param {Spaces_Imageviewer_Loading_ImageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_imageviewer_loading_image = /** @type {((inputs?: Spaces_Imageviewer_Loading_ImageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Imageviewer_Loading_ImageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bild wird geladen...")
	return /** @type {LocalizedString} */ ("Loading image...")
});